import React, { useState, useEffect } from "react";
import PlanCard from "./PlanCard";
import { Box, Card, Grid, Tab, Tabs, Typography } from "@mui/material";
import { DecorativeCorner } from "../common/DecorativeCorner";
import axios from 'axios';
import { styles } from "../styles/styles";
function PricingSection() {
	const [selectedTab, setSelectedTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue);
	};
	const [plansdata, setPlansdata] = useState([]);

	const plansdetalies = async () => {
		const Responsive = await axios.get(
			`${process.env.REACT_APP_API_BASE_URL}/customer-plans`
		);
		if (Responsive.data.data) {
			setPlansdata(Responsive.data.data);
		} else {
			alert("data not avaliable");
			console.log(plansdata);
		}
	};
	useEffect(() => {
		plansdetalies();
	},[]);
	return (
		<div>
			<Card
				sx={{
					...styles.payuse,
					height: { xs: "auto", sm: 615 },
					padding: { xs: 2, sm: 4 },
				}}
			>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<Typography variant="h4" component="h1" sx={styles.heading}>
					Matrimony Privilege Plans
				</Typography>

				<Box sx={styles.tabsContainerStyles}>
					<Tabs
						value={selectedTab}
						onChange={handleTabChange}
						sx={{
							...styles.tabsStyles,
							"& .MuiTab-root": {
								fontSize: { xs: "0.75rem", sm: "0.875rem" },
								minWidth: "auto",
								flexShrink: 1, 
								paddingX: { xs: 1, sm: 2 },
							},
						}}
						variant="scrollable"
						scrollButtons="auto"
					>
						<Tab label="Standard Package" sx={styles.tabStyles} />
						<Tab label="Ultimate Package" sx={styles.tabStyles} />
						<Tab label="Aristocat Package" sx={styles.tabStyles} />
					</Tabs>
				</Box>

				<Grid
					container
					spacing={3}
					justifyContent="center"
					sx={{ padding: { xs: 1, sm: 3 } }} 
				>
					{plansdata.map((plan, index) => (
						<Grid
							item
							key={index}
							xs={12} 
							sm={6} 
							md={4} 
							sx={{
								height: { xs: "auto", sm: 261 }, 
								width: { xs: "100%", sm: 303 }, 
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								marginBottom: { xs: 2, sm: 0 }, 
							}}
						>
							<PlanCard
								title={plan.planName}
								price={plan.planAmount}
								duration={plan.duration}
								durationType={plan.durationType}
								contactsAllowed={plan.noOfContacts}
								discount={plan.planDiscount}
								styles={styles.planCardStyles}
							/>
						</Grid>
					))}
				</Grid>
			</Card>
		</div>
	);
}
export default PricingSection;
